import React from 'react';
import '../styles/Pricing.scss';


export default function Pricing() {
    return (
        <section id="pricing" className="pricing">
            <div className="container">
                <h2>Pricing & Offers</h2>
                <div className="pricing-card">
                    <div className="price-visual">
                        <div className="launchprice">₹750</div>
                        <div className="preprice">₹550</div>
                        <div className="unit">/ sq.ft</div>
                    </div>
                    <div className="price-body">
                        <h3>10,000 sq.ft. @ ₹550/sq.ft</h3>
                        <p className="note">Only ₹55 Lakhs — Introductory (Pre)  launch price.  <b>Official Launch Price will be 750 /- Per Sq.ft</b></p>
                        <div className="actions">
                            <a className="btn primary" href="#contact">Book Site Visit</a>
                            <a className="btn ghost" href="tel:+919730020099">Call Now</a>
                            <a className="btn ghost" href="https://wa.me/919730020099">WhatsApp Us</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}